// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"225":"very-logo","305":"ocean-logo","467":"ASOS-logo","638":"capital-one-logo","749":"littlewoods-logo","766":"think-money-logo","908":"luma-logo"}[chunkId] + "." + {"225":"c5ad2aab","305":"5d9c7af4","467":"4181d381","638":"aa0d02c8","749":"de504ee7","766":"d30b9b1c","908":"6a1a55a3"}[chunkId] + ".chunk.js";
};